"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _theme = require("../theme");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n        min-width: ", "px;\n        top: ", "px;\n        opacity: ", ";\n        right: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n        background-color: ", ";\n        box-shadow: ", ";\n        border-radius: ", ";\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var styles = {
  dropdown: {
    optionsContainer: function optionsContainer(_ref) {
      var theme = _ref.theme;
      var select = theme.components.select;
      return (0, _theme.css)(_templateObject(), select.dropdown.backgroundColor, select.dropdown.boxShadow, select.dropdown.borderRadius);
    },
    container: function container(_ref2) {
      var theme = _ref2.theme,
          isOpen = _ref2.isOpen,
          alignRight = _ref2.alignRight;
      var select = theme.components.select;
      return (0, _theme.css)(_templateObject2(), select.dropdown.minWidth, isOpen ? 'inherit' : -10, isOpen ? 1 : 0, alignRight && 0);
    }
  }
};
var _default = styles;
exports.default = _default;